import * as ss from "superstruct";
import { phone } from "phone";

export const contacts = ["email", "phone", "text"] as const;

function phoneNumber(code?: string) {
  if (!code) return ss.string();

  return ss.refine(ss.string(), "phoneNumber", (value) => {
    if (!value) return false;
    return phone(value, { country: code }).isValid;
  });
}

const contactStruct = ss.enums(contacts);

const emailStruct = ss.refine(ss.string(), "email", (value) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value));

export type ContactFormSchema = {
  fullname: string;
  phone: string;
  email: string;
  contact: (typeof contacts)[number];
  message: string;
};

const CACHE = new Map<string | undefined, ss.Struct<ContactFormSchema>>();

export function createSchema(code?: string) {
  const cached = CACHE.get(code);
  if (cached) return cached;
  const schema = ss.object({
    fullname: ss.nonempty(ss.string()),
    phone: ss.defaulted(phoneNumber(code), ""),
    email: ss.defaulted(emailStruct, ""),
    contact: ss.defaulted(contactStruct, "email"),
    message: ss.nonempty(ss.string()),
  });
  CACHE.set(code, schema);
  return schema;
}

export default createSchema;
